/* eslint-disable react/jsx-no-target-blank */
import {
  Box,
  IconButton,
  HStack,
  Spacer,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useRef } from "react";
import { Image } from "react-bootstrap";
import logo from "../assets/sufiNav.png";
import logo2 from "../assets/sufiNav2.png";
import { ImLinkedin2 } from "react-icons/im";
import { Link } from "react-scroll";
import useActiveSection from "../hooks/useActiveSection"; // ✅ Add this
import { useNav } from "../context/NavContext";

const Links = [
  { name: "Home", link: "home" },
  { name: "About", link: "about" },
  { name: "Projects", link: "projects" },
  { name: "Skills", link: "skills" },
  { name: "Contact", link: "contact" },
];

const Navbar = () => {
  const activeSection = useActiveSection();
  const { manualClick, setActiveSection } = useNav();

  const bg = useColorModeValue(
    "#EBF8FF",
    "linear-gradient(0deg, rgba(64,57,53,1) 0%, rgba(37,32,32,1) 31%)"
  );

  const MainFont = useColorModeValue("#302e4c", "#eac288");

  const borderBottomColor = useColorModeValue(
    "3px solid #e53e3e",
    "3px solid #eac288"
  );

  const suFiLogo = useColorModeValue(logo, logo2);

  const buttonColor = useColorModeValue(
    "#e53e3e",
    "linear(to-b, #ffdda1, #b07844)"
  );

  return (
    <HStack
      bg={bg}
      zIndex={998}
      style={{ position: "fixed", top: 0 }}
      p="0px 5%"
      justify="center"
      w="100%"
      h="64px"
      borderBottom={borderBottomColor}
    >
      <Stack minW="80px" w="120px" alignItems="center">
        <Image w="100%" src={suFiLogo} alt="su-Fi-logo" />
      </Stack>

      <Spacer />

      <Box display={{ base: "none", md: "none", lg: "block" }}>
        <HStack>
          {Links.map((el, i) => {
            const isActive = activeSection === el.link;

            return (
              <Link
                key={i}
                to={el.link}
                smooth={true}
                offset={0}
                duration={500}
                onClick={() => {
                  manualClick.current = true;
                  setActiveSection(el.link);
                  setTimeout(() => {
                    manualClick.current = false;
                  }, 700);
                }}
              >
                <Text
                  padding="5px 20px"
                  borderRadius={30}
                  color={isActive ? "white" : MainFont}
                  bg={isActive ? buttonColor : "none"}
                  fontSize="18px"
                >
                  {el.name}
                </Text>
              </Link>
            );
          })}

          <a
            href="https://www.linkedin.com/in/sufiyan-shaikh-developer"
            target="_blank"
          >
            <IconButton
              mr={5}
              display={{ base: "none", md: "-webkit-inline-flex" }}
              size="md"
              borderRadius="5"
              fontSize="xl"
              bgGradient={buttonColor}
              colorScheme="red"
              icon={<ImLinkedin2 />}
            />
          </a>
        </HStack>
      </Box>
    </HStack>
  );
};

export default Navbar;
